__turbopack_context__.v({
  "className": "figtree_aa265da-module__tR1WBG__className",
});
